import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import '../../css/login.css';
import ApiService from '../../../../services/api';
import { toast } from "react-toastify";
import unlock from '../../../../media/eye1.png';
import lock from '../../../../media/eye2.png';
import Select from "react-select";




function UserRegister() {
  const [loading, setLoading] = useState(true);
  const [countries, setCountries] = useState([]);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    nation: 'IT',
    city: '',
    tax_id: '',
    acceptTerms: false,
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState('');
  const [step, setStep] = useState("register");
  const navigate = useNavigate();

 
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [ captchaID, setCaptchaID ] = useState();
  const [ captchaURL, setCaptchaURL ] = useState();
  const [ captchaValue, setCaptchaValue ] = useState();


  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await ApiService.getCountries();
        setCountries(res);
      } catch (err) {
        console.error('Errore:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, []);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value
    });
  };

 const handleSubmit = async (e) => {
    e.preventDefault();


    setErrors({});
    setMessage('');
    
    


    try {

      const payload = {
        ...formData,
        captcha_id: captchaID,
        captcha_value: captchaValue,
      };


      await ApiService.requestRegistration(payload);

      setStep("email_sent");


    } catch (err) {

      if (err.response?.data) {

        setErrors(err.response.data);

        if (err.response?.data?.captcha_refresh) {
          fetchCaptcha();
        }

      } else {

        setMessage("Errore nella registrazione.");

      }
    }
  };

  const getErrorMessage = field => {
    if (!errors[field]) return null;
    return Array.isArray(errors[field]) ? errors[field][0] : errors[field];
  };

  

  const fetchCaptcha = async() => {
    try {
        let responseData = await ApiService.getCaptcha();
        setCaptchaID(responseData.captcha_id);
        setCaptchaURL(responseData.captcha_url);
        setCaptchaValue("");
    } catch (error) {
        console.error('Error fetching captcha:', error);
    }
}

useEffect(() => {
    fetchCaptcha();
}, []);

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "48px",
      borderRadius: "14px",
      backgroundColor: "#fff",
      border: state.isFocused
        ? "1px solid #cecdcd"
        : "1px solid #e5e7eb",
      boxShadow: state.isFocused
        ? "0 0 0 4px rgba(206,205,205,0.25)"
        : "none",
      transition: "all 0.2s ease",

      "&:hover": {
        borderColor: "#cecdcd"
      }
    }),

    valueContainer: (provided) => ({
      ...provided,
      padding: "0 14px"
    }),

    placeholder: (provided) => ({
      ...provided,
      color: "#cecdcd",
      fontWeight: 400
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#393939",
      fontWeight: 500
    }),

    menu: (provided) => ({
      ...provided,
      marginTop: "8px",
      borderRadius: "14px",
      overflow: "hidden",
      border: "1px solid #e5e7eb",
      boxShadow: "0 12px 30px rgba(0,0,0,0.08)"
    }),

    menuList: (provided) => ({
      ...provided,
      padding: "6px"
    }),

    option: (provided, state) => ({
      ...provided,
      borderRadius: "10px",
      marginBottom: "2px",
      padding: "12px 14px",
      cursor: "pointer",
      transition: "all 0.15s ease",

      backgroundColor: state.isSelected
        ? "#cecdcd"
        : state.isFocused
        ? "#f5f5f5"
        : "#fff",

      color: "#393939",
      fontWeight: state.isSelected ? 600 : 500
    }),

    indicatorSeparator: () => ({
      display: "none"
    }),

    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: state.isFocused
        ? "#393939"
        : "#cecdcd",

      "&:hover": {
        color: "#393939"
      }
    }),

    clearIndicator: (provided) => ({
      ...provided,
      color: "#cecdcd",

      "&:hover": {
        color: "#393939"
      }
    })
  };

  if (loading) {
    return ;
  }

  return (
    <div className="login-container">
      <div className="login-flex-wrapper">
        <h1 className="login-title">Registrazione</h1>

        <div className="login-form-box2">
          {
          step === "register" && (
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Nome</label>
                <input
                  name="first_name"
                  onChange={handleChange}
                  value={formData.first_name}
                  required
                />
                {getErrorMessage('first_name') && (
                  <p className="error">{getErrorMessage('first_name')}</p>
                )}
              </div>
              <div className="form-group">
                <label>Cognome</label>
                <input
                  name="last_name"
                  onChange={handleChange}
                  value={formData.last_name}
                  required
                />
                {getErrorMessage('last_name') && (
                  <p className="error">{getErrorMessage('last_name')}</p>
                )}
              </div>
            </div>

            <div className="form-group">
              <label>Username</label>
              <input
                name="username"
                onChange={handleChange}
                value={formData.username}
                required
              />
              {getErrorMessage('username') && (
                <p className="error">{getErrorMessage('username')}</p>
              )}
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                name="email"
                type="email"
                onChange={handleChange}
                value={formData.email}
                required
              />
              {getErrorMessage('email') && (
                <p className="error">{getErrorMessage('email')}</p>
              )}
            </div>

            <div className="form-group">
              <label>Password:</label>

              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="password-input"
                  required
                />

                <button
                  type="button"
                  onClick={() => setShowPassword(prev => !prev)}
                  className="toggle-password-btn"
                >
                  <img
                    src={showPassword ? lock : unlock}
                    alt="toggle password"
                    className="eye-icon"
                  />
                </button>
              </div>
              {getErrorMessage('password') && (
                  <p className="error">
                    {getErrorMessage('password')}
                  </p>
                )}
            </div>

            <div className="form-group">
              <label>Conferma Password:</label>

              <div className="password-wrapper">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className="password-input"
                  required
                />

                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(prev => !prev)}
                  className="toggle-password-btn"
                >
                  <img
                    src={showConfirmPassword ? lock : unlock}
                    alt="toggle confirm password"
                    className="eye-icon"
                  />
                </button>
              </div>
              {getErrorMessage('confirmPassword') && (
                  <p className="error">
                    {getErrorMessage('confirmPassword')}
                  </p>
                )}
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Nazione</label>
                <Select
                  options={countries}
                  value={
                    countries.find(
                      c => c.value === formData.nation
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    setFormData({
                      ...formData,
                      nation: selectedOption?.value || ""
                    })
                  }
                  placeholder="Seleziona nazione"
                  isSearchable
                  styles={customSelectStyles}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "#cecdcd",
                      primary25: "#f5f5f5",
                      primary50: "#cecdcd"
                    }
                  })}
                />
                {getErrorMessage('nation') && (
                  <p className="error">{getErrorMessage('nation')}</p>
                )}
              </div>

              <div className="form-group">
                <label>Città / Località</label>
                <input
                  name="city"
                  onChange={handleChange}
                  value={formData.city}
                  required
                />
                {getErrorMessage('city') && (
                  <p className="error">{getErrorMessage('city')}</p>
                )}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Codice Fiscale</label>
                <input
                  name="tax_id"
                  onChange={handleChange}
                  value={formData.tax_id}
                  maxLength={16}
                  required
                />
                {getErrorMessage('tax_id') && (
                  <p className="error">{getErrorMessage('tax_id')}</p>
                )}
              </div>
            </div>
            
            <div className="terms-checkbox">
              <label>
                <input
                  type="checkbox"
                  name="acceptTerms"
                  checked={formData.acceptTerms}
                  onChange={handleChange}
                />

                <span>
                 Esprimo il consenso al trattamento dei miei dati personali secondo le modalità e finalità esplicitate nell'<a href='/informativa-privacy'>Informativa Privacy art. 13 GDPR UE 2016/679</a>.
                </span>
              </label>

              {getErrorMessage('acceptTerms') && (
                <p className="error">
                  {getErrorMessage('acceptTerms')}
                </p>
              )}
            </div>

            <div className="form-row captcha-row">
              <div className="form-group captcha-image-group">
                {captchaURL && (
                  <img
                    src={window.env.BACKEND_BASE_URL + captchaURL}
                    alt="Captcha"
                    className="captcha-image"
                  />
                )}

                <button
                  type="button"
                  onClick={fetchCaptcha}
                  className="captcha-refresh-btn"
                >
                  Rigenera Codice
                </button>
              </div>

              <div className="form-group captcha-input-group">
                <label>Inserisci il codice che visualizzi:</label>

                <input
                  name="captcha"
                  value={captchaValue || ""}
                  onChange={(e) => setCaptchaValue(e.target.value)}
                  required
                />
                {getErrorMessage('captcha') && (
                  <p className="error">
                    {getErrorMessage('captcha')}
                  </p>
                )}
              </div>
            </div>

            


            <button type="submit" className="btn-login">
              Registrati
            </button>

            {message && (
              <p className="login-success">{message}</p>
            )}
          </form>
          )}
          {
          step === "email_sent" && (

          <div style={{textAlign:"center"}}>

            <h3>Email inviata</h3>

            <p>
              Ti abbiamo inviato una mail di conferma.
            </p>

            <p>
              Controlla la tua casella di posta e clicca sul link
              per completare la registrazione.
            </p>

            <button
              className="btn-login"
              onClick={() => navigate("/login")}
            >
              Torna al login
            </button>

          </div>

          )}
        </div>
      </div>
    </div>
  );
}

export default UserRegister;
